export default "__VITE_ASSET__B5VrqlR6__"